"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApToggleSwitch = void 0;
var React = require("react");
var styles_1 = require("./styles");
var ApCheckLabel_1 = require("../../internal/ApCheckLabel");
var types_1 = require("../../utils/types");
exports.ApToggleSwitch = function (_a) {
    var flexDirection = _a.flexDirection, justifyContent = _a.justifyContent, id = _a.id, children = _a.children, className = _a.className, props = __rest(_a, ["flexDirection", "justifyContent", "id", "children", "className"]);
    return (React.createElement(ApCheckLabel_1.StyledCheckLabel, { title: id, htmlFor: id, flexDirection: children ? flexDirection : 'row', justifyContent: children ? justifyContent : 'flex-start', tabIndex: 0 },
        React.createElement(styles_1.StyledToggleWrapper, { disabled: props.disabled },
            React.createElement(styles_1.StyledToggleInput, __assign({}, props, { id: id, type: props.type, defaultChecked: props.defaultChecked })),
            React.createElement(styles_1.StyledToggleSwitch, { className: "ap-toggle-switch " + (className ? className : '') })),
        children && React.createElement(ApCheckLabel_1.StyledCheckChild, null, children)));
};
exports.ApToggleSwitch.defaultProps = {
    autoFocus: false,
    disabled: false,
    theme: types_1.LIGHT,
    type: 'checkbox'
};
//# sourceMappingURL=ApToggleSwitch.js.map